import React from "react";
import PropTypes from "prop-types";

// Constants
import PAGE_BUILDER_CONTENT from "../../constants/pageBuilderContent";

const PageBuilder = ({ pageBuilderContents, classNamesObj }) => {
  return (
    <>
      {pageBuilderContents?.map((content, index) => {
        if (!content) return null;
        return (
          <React.Fragment key={index.toString()}>
            {PAGE_BUILDER_CONTENT[content._type](
              content,
              classNamesObj[content._type]
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

PageBuilder.propTypes = {
  classNamesObj: PropTypes.object,
  pageBuilderContents: PropTypes.array.isRequired,
};

PageBuilder.defaultProps = {
  classNamesObj: {},
};

export default PageBuilder;
